/* eslint-disable */
import React from "react";

export default function Code(props) {
  return (
    <div className="code">
      <footer>
      <a href="https://github.com/bethaustria/final-project" target="_blank" rel="noreferrer">GitHub</a>
      <script src="src/script.js"></script>
      <div id="root"></div>
      </footer>
    </div>
  );
}
